import { ImageURISource, TouchableOpacity } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { MBAspect } from '@shared/components/aspect';
import { MBImage } from '@shared/components/image';
import { SharedStyles } from '@shared/styles';
import { Styles } from './styles';

interface Props {
  source: ImageURISource;
  onPress: () => void;
}

export function MBGIFListRow({ source, onPress }: Props) {
  return (
    <MBView fill style={Styles.row}>
      <MBView style={Styles.rowBackground}>
        <TouchableOpacity onPress={onPress}>
          <MBAspect ratio={1}>
            <MBImage source={source} style={SharedStyles.fill} />
          </MBAspect>
        </TouchableOpacity>
      </MBView>
    </MBView>
  );
}
